// base
import { BREAKPOINTS } from 'shared/styles/base';

// constants
import { IMAGE_WIDTH } from './constants';

export const getImageWidth = (deviceWidth: number) => {
  if (deviceWidth > 1100) {
    return IMAGE_WIDTH.DESKTOP;
  }

  if (deviceWidth > BREAKPOINTS.TABLET) {
    return IMAGE_WIDTH.TABLET_BIG;
  }

  // TODO - discuss with UX for better ipad look
  if (deviceWidth > BREAKPOINTS.MOBILE) {
    return deviceWidth;
  }

  return deviceWidth;
};

export const getResponsiveImageHeight = (
  originalHeight: number,
  screenToImageRatio: number,
  isMobile: boolean
) => {
  if (window && isMobile) {
    if (originalHeight > window.screen.height * screenToImageRatio) {
      return window.screen.height * screenToImageRatio;
    }
  }
  return originalHeight;
};
